var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-case"},_vm._l((_vm.list),function(item){return _c('ListCaseItem',{key:item.id,attrs:{"title":item.title,"intro":item.intro,"img-url":item.imgUrl,"color":_vm.color,"intro-style":_vm.introStyle}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }